'use client';

import { CircleHelp } from 'lucide-react';
import type React from 'react';
import { DisclosureTooltip } from '../DisclosureTooltip/DisclosureTooltip';

// Port of legacy StarRating/components/RatingToolTip: HelpOutline icon trigger opening a
// DisclosureTooltip (click-away + Escape dismiss via Popover) with the tooltip text.
// Legacy defaults: tooltipSize 0.813rem, black icon, maxWidth 340px.
export function RatingTooltip({
  starRatingTooltip,
}: {
  starRatingTooltip: string;
}): React.JSX.Element {
  return (
    <DisclosureTooltip
      placement="top"
      trigger={
        <button
          aria-label="NerdWallet rating info"
          className="typography-text-small inline-flex cursor-pointer bg-transparent p-0 align-middle text-foreground"
          type="button"
        >
          <CircleHelp aria-hidden className="text-[0.813rem]" size="0.813rem" />
        </button>
      }
    >
      <span className="typography-text-small">{starRatingTooltip}</span>
    </DisclosureTooltip>
  );
}
